import { priceFormatter } from '@2wunder/klarx-tool'
import { ClockCircleOutlined, EuroCircleOutlined } from '@ant-design/icons'
import KInfo from 'app/components/Modules/DataDisplay/KInfo'
import { RecordType } from 'app/constants/GlobalTypes'
import React from 'react'

type Props = {
  priceList: IPriceList
}

const PriceListInfo: React.FC<Props> = ({ priceList }) => {
  return (
    <KInfo
      grid={{ column: 2 }}
      recordType={RecordType.price_list}
      member={{
        validity: {
          value: `${priceList.validFrom} - ${priceList.validTo}`,
          icon: <ClockCircleOutlined className="text-lg" />
        },
        target_revenue: {
          value: priceFormatter(priceList.customerTargetRevenue),
          icon: <EuroCircleOutlined className="text-lg" />
        }
      }}
    />
  )
}

export default PriceListInfo
